import Backbone from 'backbone';
import sidebars from '../../sidebars/index.js';
import studioPlugin from '../../studioPlugins/index.js';
const $ = Backbone.$;

export default {
  run(editor, sender, opts = {}) {
    var command_type = sender.get('command');
    switch (command_type) {
      case 'open-menu':
        sidebars.openSimpleMenu();
        break;
      default:
        console.log(opts);
        break;
    }
  },
  stop(editor, sender) {
    var command = sender.get('command');
    switch (command) {
      case 'open-menu':
        sidebars.closeSimpleMenu();
        break;
      default:
        break;
    }
  }
};
